import ReducerUtilities from '../../../shared/store/reducer-utilities';
import taskModel from '../../models/task';
import tasksCommitTypes from '../tasks/commit-types';

const INITIAL_TASKS_STATE = {
  isAddingTask: false,
  isEditingTask: null,
  isLoading: [],
  list: null,
  selectedTask: null,
};

function tasksReducers(state = INITIAL_TASKS_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case tasksCommitTypes.PUSH_TASK:
      return {
        ...state,
        list: [...state.list, taskModel(action.task)],
      };
    case tasksCommitTypes.PUSH_TASKS:
      return {
        ...state,
        list: [...action.tasks.map(item => taskModel(item))],
      };
    case tasksCommitTypes.REMOVE_TASK:
      return {
        ...state,
        list: ReducerUtilities.removeModelFromList(action.taskGuid, state.list),
      };
    case tasksCommitTypes.REPLACE_TASK:
      return {
        ...state,
        list: ReducerUtilities.replaceModelInList(
          taskModel(action.task),
          state.list,
        ),
      };
    case tasksCommitTypes.SET_IS_ADDING_TASK:
      return {
        ...state,
        isAddingTask: action.isAddingTask,
      };
    case tasksCommitTypes.SET_IS_EDITING_TASK:
      return {
        ...state,
        isEditingTask: action.isEditingTask,
      };
    case tasksCommitTypes.SET_TASK_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(
          action.isLoading,
          state.isLoading,
        ),
      };
    case tasksCommitTypes.SET_SELECTED_TASK_GUID:
      return {
        ...state,
        selectedTask: action.selectedTask,
      };
    default:
      return state;
  }
}

export default tasksReducers;
